exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".provider-panel--1cbTPEd8REOIrI_tS5F8Eo {\n  display: flex;\n  gap: .5rem;\n  flex-wrap: wrap;\n}\n\n.provider-panel--27LvS3tWQfivIolDlpDE41 input[type=\"checkbox\"]:not(:disabled):checked + label::before {\n  background: #4e89a4;\n}\n\n.provider-panel--27LvS3tWQfivIolDlpDE41 input[type=\"checkbox\"]:disabled:checked + label::before {\n  background: #b4b4af;\n  border-color: #b4b4af;\n}\n\n.provider-panel--1_P5i2HpU-7AGvGWrZQjcH {\n  color: #7c7d74;\n  font-size: .75rem;\n  line-height: 1rem;\n}\n", ""]);

// exports
exports.locals = {
	"content": "provider-panel--1cbTPEd8REOIrI_tS5F8Eo",
	"content": "provider-panel--1cbTPEd8REOIrI_tS5F8Eo",
	"checkbox": "provider-panel--27LvS3tWQfivIolDlpDE41",
	"checkbox": "provider-panel--27LvS3tWQfivIolDlpDE41",
	"fallbackMessage": "provider-panel--1_P5i2HpU-7AGvGWrZQjcH",
	"fallbackMessage": "provider-panel--1_P5i2HpU-7AGvGWrZQjcH"
};